import React, { Component } from "react";
import { TouchableOpacity, Image } from "react-native";
import { Container, Header, Title, Left, Icon, Right, Button, Body, Content,Text, Card, CardItem, CardSwiper } from "native-base";
// import { Styles } from './index';
import * as Styles from './Styles';
import { createStackNavigator } from '@react-navigation/stack';

const Stack = createStackNavigator();

export function GenerateStackRoutes({ route, navigation, screensList }) {
    return(
        <Stack.Navigator
            screenOptions={{
                headerTintColor: Styles.colorPalette.White,
                headerStyle: { backgroundColor: Styles.colorPalette.mainColor,  }
            }}
        >
            {screensList.map(screenInfo =>
                <Stack.Screen name={screenInfo.name} component={screenInfo.scrComp} 
                    options={{headerTitle: screenInfo.Title}} />
            )} 
        </Stack.Navigator>
    )
}

//TODO move profile pic up to main route navigation
export function StackNavigationHeader({ navigation }) {
    return(
        React.useLayoutEffect(() => {
          navigation.setOptions({
            headerLeft: () => (
                <Button
                    transparent
                    onPress={() => navigation.openDrawer("RootDrawer")}>
                    <Icon name="menu" style={{color: Styles.colorPalette.White}} />
                </Button>
            ),
            headerRight: () => (
              // TODO - update to pull profile photo from database
                <TouchableOpacity
                    onPress={() => navigation.navigate('SettingsStack', {screen: 'Settings'})}
                >
                    <Image
                    source={require('../assets/profilePicTesting/Hans.png')}
                    style={{height: 40, width:40, marginRight:10, borderRadius:400/2}}
                    />
                </TouchableOpacity>
            ),
          });
        }, [navigation])
    )
  }